import { render } from "./LandingPageHome.vue?vue&type=template&id=67e9d558&scoped=true"
import script from "./LandingPageHome.vue?vue&type=script&lang=js"
export * from "./LandingPageHome.vue?vue&type=script&lang=js"

import "./LandingPageHome.vue?vue&type=style&index=0&id=67e9d558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e9d558"]])

export default __exports__